import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import {
  IReducerFamilyState,
  FETCH_FAMILY,
  FETCH_FAMILIES,
  FamilyActionTypes,
} from './types';

const initialState: IReducerFamilyState = {
  all: undefined,
  current: undefined,
};

const persistConfig = {
  storage,
  key: 'families',
  whitelist: ['all'],
};

const reducers = (state = initialState, action: FamilyActionTypes) => {
  switch (action.type) {
    case FETCH_FAMILIES:
      return {
        ...state,
        all: action.payload,
      };
    case FETCH_FAMILY:
      return {
        ...state,
        current: action.payload,
      };

    default:
      return state;
  }
};

export default persistReducer(persistConfig, reducers);
